import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const IntunePage = () => {
  const articles = [
    {
      slug: '/intune/modern-cihaz-yonetimi',
      tag: 'Cihaz Yönetimi',
      date: '14 Nisan 2025',
      readTime: '10 dk okuma',
      title: 'Modern Cihaz Yönetimi: Microsoft Intune ile Kurumsal Endpoint Güvenliği',
      description:
        'Microsoft Intune kullanarak kurumsal cihazları güvenli bir şekilde yönetin, Autopilot ile otomatik dağıtım yapın ve BYOD senaryolarını koruyun.',
      image:
        'https://public.readdy.ai/ai/img_res/2705ca96bd96d23201d8935528ce3f43.jpg',
      icon: 'ri-device-line',
      accent: 'from-orange-500 to-red-500',
      accentBg: 'bg-orange-500',
    },
    {
      slug: '/intune/uygulama-koruma-politikalari',
      tag: 'Uygulama Koruma',
      date: '18 Ağustos 2025',
      readTime: '8 dk okuma',
      title: 'Intune Uygulama Koruma Politikaları: BYOD Güvenlik Rehberi',
      description:
        'BYOD senaryolarında kurumsal verileri korumak için uygulama koruma politikalarını yapılandırma ve Conditional Access entegrasyonu.',
      image:
        'https://readdy.ai/api/search-image?query=futuristic%20mobile%20application%20security%20concept%20with%20glowing%20orange%20shield%20protecting%20corporate%20data%20on%20smartphones%20and%20tablets%20with%20abstract%20digital%20lock%20patterns%20and%20encrypted%20data%20streams%20flowing%20on%20dark%20sleek%20background&width=800&height=500&seq=intune-app-protect-2&orientation=landscape',
      icon: 'ri-apps-line',
      accent: 'from-amber-500 to-orange-600',
      accentBg: 'bg-amber-500',
    },
    {
      slug: '/intune/windows-autopilot',
      tag: 'Windows Autopilot',
      date: '9 Haziran 2025',
      readTime: '11 dk okuma',
      title: 'Windows Autopilot ile Sıfır Dokunuş Cihaz Dağıtımı',
      description:
        'Autopilot kullanarak Windows cihazlarını otomatik olarak yapılandırın, dağıtın ve kullanıcı deneyimini optimize edin.',
      image:
        'https://readdy.ai/api/search-image?query=automated%20windows%20device%20deployment%20concept%20with%20glowing%20orange%20rocket%20launching%20from%20a%20laptop%20screen%20surrounded%20by%20floating%20configuration%20icons%20and%20setup%20wizards%20on%20a%20sleek%20dark%20technology%20background%20with%20abstract%20cloud%20elements&width=800&height=500&seq=intune-autopilot-4&orientation=landscape',
      icon: 'ri-rocket-line',
      accent: 'from-red-500 to-orange-500',
      accentBg: 'bg-red-500',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-orange-500 to-red-600 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)',
            }}
          />
        </div>
        <div className="relative max-w-6xl mx-auto px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm rounded-lg mb-6">
              <span className="text-white text-sm font-medium">ENDPOINT MANAGEMENT</span>
            </div>
            <h1 className="text-5xl font-bold text-white mb-6">Microsoft Intune</h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Modern cihaz yönetimi, endpoint güvenliği ve uygulama koruma politikaları hakkında derinlemesine teknik makaleler
            </p>
          </motion.div>
        </div>
      </section>

      {/* Makaleler */}
      <section className="py-24 bg-[#FAFBFC]">
        <div className="max-w-6xl mx-auto px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Intune Makaleleri</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Microsoft Intune hakkında derinlemesine teknik içerikler
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {articles.map((article, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.15, duration: 0.5 }}
              >
                <Link
                  to={article.slug}
                  className="group block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer border border-gray-100 hover:border-transparent"
                >
                  {/* Görsel Alanı */}
                  <div className="relative w-full h-56 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

                    {/* Üst Badge */}
                    <div className="absolute top-4 left-4 flex items-center space-x-2">
                      <span
                        className={`${article.accentBg} text-white text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap flex items-center space-x-1.5 shadow-lg`}
                      >
                        <i className={`${article.icon} text-sm`}></i>
                        <span>{article.tag}</span>
                      </span>
                    </div>

                    {/* Alt Bilgi */}
                    <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <span className="text-white/80 text-xs flex items-center space-x-1">
                          <i className="ri-calendar-line text-sm"></i>
                          <span>{article.date}</span>
                        </span>
                        <span className="text-white/80 text-xs flex items-center space-x-1">
                          <i className="ri-time-line text-sm"></i>
                          <span>{article.readTime}</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* İçerik Alanı */}
                  <div className="p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-sm text-gray-500 leading-relaxed mb-5">{article.description}</p>

                    {/* Alt Kısım */}
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <div className="flex items-center space-x-2">
                        <div className={`w-8 h-8 rounded-full bg-gradient-to-br ${article.accent} flex items-center justify-center`}>
                          <i className="ri-device-line text-white text-sm"></i>
                        </div>
                        <span className="text-xs text-gray-500 font-medium">Intune Rehberi</span>
                      </div>
                      <div className="flex items-center space-x-2 text-orange-600 text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <span className="whitespace-nowrap">Devamını Oku</span>
                        <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Diğer Konular */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Diğer Konulara Göz Atın</h2>
            <p className="text-lg text-gray-600 mb-8">
              Microsoft güvenlik çözümleri hakkında daha fazla içerik keşfedin
            </p>
            <div className="flex items-center justify-center space-x-4 flex-wrap gap-y-3">
              <Link
                to="/sentinel"
                className="px-8 py-3 bg-[#0078D4] hover:bg-[#006abc] text-white font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Sentinel
              </Link>
              <Link
                to="/edr"
                className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Microsoft EDR
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IntunePage;
